import { ViewSalesFunnelPageHeader } from '@pages/SalesFunnels/ViewSalesFunnel/components';
import { ViewSalesFunnel } from '@pages/SalesFunnels/ViewSalesFunnel/ViewSalesFunnel.main';

export { ViewSalesFunnel, ViewSalesFunnelPageHeader };
